<template>
  <div class="obstacles-container">
    <van-nav-bar :fixed="true" left-arrow left-text="返回" @click-left="onClickLeftBack"></van-nav-bar>
    <div style="width: 100%;height:50px;"></div>
    <!-- <button @click="startOrStopRecording">
      {{ isRecording ? 'Stop Recording' : 'Start Recording' }}
    </button> -->
    <div class="practice-stage" style="width: 100%; height: 200px;position: fixed;border-bottom: 1px solid skyblue;">
      <div
        v-for="(value, index) in visibleObstacles"
        :key="'ob-' + index + '-' + (value.note || '') + '-' + value.height"
      >
        <Obstacle
          ref="obstacle"
          :height="value.height"
          :width="value.width"
          :delay="value.delay"
          :note="value.note"
          :match-state="value.matchState || 'idle'"
          :active="index === activeObstacleIndex"
          :start-delay="value.startDelay || 0"
          :travel="value.travel || 6"
          :cross="value.cross || 5.5"
        />
      </div>
      <AudioVisualizer
        :is-recording="isRecording"
        :target-heights="visibleObstacles"
        :size="40"
        @altitude="onAltitude"
      />
    </div>
    <div style="height: 200px;"></div>
    <div
      style="width: 100%;margin-top: 20px;display: flex;flex-direction: column; justify-content: center;align-items: center;">
      <div style="width: 70%;">
        <el-tabs :stretch="true" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane name="0">
            <span slot="label"> 初级阶段</span>
          </el-tab-pane>
          <el-tab-pane name="1">
            <span slot="label"> 进阶阶段</span>

          </el-tab-pane>
          <el-tab-pane name="2">
            <span slot="label"> 高级阶段</span>
          </el-tab-pane>

        </el-tabs>


      </div>
      <div class="stage-tip">{{ stageTip }}</div>
      <div class="practice-note" v-if="practiceNoteText">{{ practiceNoteText }}</div>
      <div class="list-view" :style="{ height: screenHeight }">
        <el-row :gutter="10">
          <el-col :span="8" v-for="(item, index) in currentList" :key="item.id">
            <el-card :body-style="{ padding: '0px' }" :class="{ 'selected': index == selectScale }">
              <div class="practice-card" @click="selectItem(index)">
                <div class="nav">
                  <span class="card-title">{{ item.title }}</span>
                  <span class="card-tip" v-if="item.tip">{{ item.tip }}</span>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="kuang">
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
    </div>
  </div>
</template>

<script>
import Obstacle from '@/components/Obstacle.vue';
import AudioVisualizer from '@/components/ImageDanceMobile.vue';

export default {
  components: {
    Obstacle,
    AudioVisualizer,

  },
  data() {
    return {
      obstacleHeights: [{ id: 1, width: 0, height: 0, delay: 0 }], // 障碍物的高度数组
      isRecording: false,
      // 屏幕宽度
      screenWidth: window.screen.width,
      // 屏幕高度
      screenHeight: (window.screen.height - 400) + "px",
      colSpan: 24,
      currentIndex: 0,
      muted: false,
      autoplay: false,
      // 初级：单音音阶（同宽，先练音高）
      scaleList: [
        { id: 1, title: '1', tip: 'do', obstacles: [{ width: 28, height: 30, delay: 3, note: '1' }] },
        { id: 2, title: '2', tip: 're', obstacles: [{ width: 28, height: 40, delay: 3, note: '2' }] },
        { id: 3, title: '3', tip: 'mi', obstacles: [{ width: 28, height: 50, delay: 3, note: '3' }] },
        { id: 4, title: '4', tip: 'fa', obstacles: [{ width: 28, height: 60, delay: 3, note: '4' }] },
        { id: 5, title: '5', tip: 'sol', obstacles: [{ width: 28, height: 70, delay: 3, note: '5' }] },
        { id: 6, title: '6', tip: 'la', obstacles: [{ width: 28, height: 80, delay: 3, note: '6' }] },
        { id: 7, title: '7', tip: 'si', obstacles: [{ width: 28, height: 90, delay: 3, note: '7' }] },
      ],
      // 进阶：节奏与短句（宽度=时值，高度=音高）
      rhythmList: [
        { id: 1, title: '长音保持', tip: '一口气吹稳', obstacles: [{ width: 96, height: 50, delay: 6, note: '3' }] },
        { id: 2, title: '短音连击', tip: '同音反复', obstacles: [{ width: 16, height: 50, delay: 1.2, note: '3' }, { width: 16, height: 50, delay: 1.2, note: '3' }, { width: 16, height: 50, delay: 1.2, note: '3' }, { width: 16, height: 50, delay: 1.2, note: '3' }] },
        { id: 3, title: '二度级进', tip: '12 23 34', obstacles: [{ width: 28, height: 30, delay: 2, note: '1' }, { width: 28, height: 40, delay: 2, note: '2' }] },
        { id: 4, title: '节奏型', tip: '短短 · 长', obstacles: [{ width: 16, height: 50, delay: 1.2, note: '3' }, { width: 16, height: 50, delay: 1.2, note: '3' }, { width: 72, height: 50, delay: 3.5, note: '3' }] },
        { id: 5, title: '三音动机', tip: '123 / 321', obstacles: [{ width: 24, height: 30, delay: 2, note: '1' }, { width: 24, height: 40, delay: 2, note: '2' }, { width: 40, height: 50, delay: 2.5, note: '3' }] },
        { id: 6, title: '四音上下', tip: '1234 / 4321', obstacles: [{ width: 22, height: 30, delay: 1.8, note: '1' }, { width: 22, height: 40, delay: 1.8, note: '2' }, { width: 22, height: 50, delay: 1.8, note: '3' }, { width: 36, height: 60, delay: 2.4, note: '4' }] },
        { id: 7, title: '回声模仿', tip: '看轨跟吹', obstacles: [{ width: 24, height: 40, delay: 2, note: '2' }, { width: 36, height: 50, delay: 2.4, note: '3' }, { width: 24, height: 40, delay: 2, note: '2' }, { width: 48, height: 30, delay: 3, note: '1' }] },
      ],
      // 高级：《小星星》分句（宽=时值）
      songLevelList: [
        { id: 1, title: '第1关', tip: '11 55', obstacles: [{ width: 24, height: 30, delay: 2, note: '1' }, { width: 24, height: 30, delay: 2, note: '1' }, { width: 24, height: 70, delay: 2, note: '5' }, { width: 24, height: 70, delay: 2, note: '5' }] },
        { id: 2, title: '第2关', tip: '66 5-', obstacles: [{ width: 24, height: 80, delay: 2, note: '6' }, { width: 24, height: 80, delay: 2, note: '6' }, { width: 64, height: 70, delay: 3.5, note: '5' }] },
        { id: 3, title: '第3关', tip: '44 33', obstacles: [{ width: 24, height: 60, delay: 2, note: '4' }, { width: 24, height: 60, delay: 2, note: '4' }, { width: 24, height: 50, delay: 2, note: '3' }, { width: 24, height: 50, delay: 2, note: '3' }] },
        { id: 4, title: '第4关', tip: '22 1-', obstacles: [{ width: 24, height: 40, delay: 2, note: '2' }, { width: 24, height: 40, delay: 2, note: '2' }, { width: 64, height: 30, delay: 3.5, note: '1' }] },
        { id: 5, title: '慢速整段', tip: '跟轨慢吹', obstacles: [{ width: 32, height: 30, delay: 3, note: '1' }, { width: 32, height: 30, delay: 3, note: '1' }, { width: 32, height: 70, delay: 3, note: '5' }, { width: 32, height: 70, delay: 3, note: '5' }, { width: 32, height: 80, delay: 3, note: '6' }, { width: 32, height: 80, delay: 3, note: '6' }, { width: 72, height: 70, delay: 4.5, note: '5' }] },
        { id: 6, title: '常速整段', tip: '跟轨常速', obstacles: [{ width: 22, height: 30, delay: 2, note: '1' }, { width: 22, height: 30, delay: 2, note: '1' }, { width: 22, height: 70, delay: 2, note: '5' }, { width: 22, height: 70, delay: 2, note: '5' }, { width: 22, height: 80, delay: 2, note: '6' }, { width: 22, height: 80, delay: 2, note: '6' }, { width: 56, height: 70, delay: 3.2, note: '5' }] },
        { id: 7, title: '闯关', tip: '独立完成', obstacles: [{ width: 22, height: 30, delay: 2, note: '1' }, { width: 22, height: 30, delay: 2, note: '1' }, { width: 22, height: 70, delay: 2, note: '5' }, { width: 22, height: 70, delay: 2, note: '5' }, { width: 22, height: 80, delay: 2, note: '6' }, { width: 22, height: 80, delay: 2, note: '6' }, { width: 56, height: 70, delay: 3.2, note: '5' }] },
      ],
      activeName: '0',
      selectTabName: 0,
      selectScale: -1,
      activeObstacleIndex: 0,
      currentMatchState: 'idle',
      practiceNoteText: '',
    };
  },
  computed: {
    currentList() {
      if (this.selectTabName === 1) return this.rhythmList
      if (this.selectTabName === 2) return this.songLevelList
      return this.scaleList
    },
    visibleObstacles() {
      return (this.obstacleHeights || []).filter((o) => o && o.height > 0)
    },
    stageTip() {
      const tips = [
        '初级阶段：高度=音高，把小鸟对准柱顶',
        '进阶阶段：高度=音高，宽度=延长音；',
        '高级阶段：《小星星》分句；看见拖长的宽柱就要延长音'
      ]
      return tips[this.selectTabName] || tips[0]
    },
  },
  methods: {
    noteHeightMap() {
      return { 1: 30, 2: 40, 3: 50, 4: 60, 5: 70, 6: 80, 7: 90 }
    },
    noteNameMap() {
      return { 1: 'do', 2: 're', 3: 'mi', 4: 'fa', 5: 'sol', 6: 'la', 7: 'si' }
    },
    heightToNote(h) {
      const map = this.noteHeightMap()
      let best = 1
      let bestDiff = Infinity
      Object.keys(map).forEach((n) => {
        const d = Math.abs(h - map[n])
        if (d < bestDiff) {
          bestDiff = d
          best = Number(n)
        }
      })
      return best
    },
    // 进阶：随机起音，保持原有音程关系（并保证落在 1-7）
    // 固定过屏速度；按柱宽拉开开拍间隔；整圈=间隔累计+过屏，末段 keyframe 停在屏外
    withStartTiming(obstacles) {
      const CROSS = 5.5
      const SCREEN = 360
      const margin = 30
      const base = this.selectTabName === 2 ? 0.95 : 1.05
      let t = 0
      const timed = obstacles.map((o) => {
        const startDelay = t
        const width = Number(o.width) || 24
        // 像素间距 ≈ gap/CROSS*SCREEN，需大于柱宽，否则宽柱会盖住邻音（如 5 压 1）
        const gap = Math.max(base, ((width + margin) * CROSS) / SCREEN)
        t += gap
        return {
          ...o,
          startDelay,
          matchState: o.matchState || 'idle'
        }
      })
      const travel = t + CROSS
      return timed.map((o) => ({ ...o, travel, cross: CROSS }))
    },
    withRandomRhythmNotes(obstacles) {
      const degrees = obstacles.map((o) => {
        if (o.note) return Number(o.note)
        return this.heightToNote(o.height)
      })
      const minDeg = Math.min.apply(null, degrees)
      const maxDeg = Math.max.apply(null, degrees)
      const span = maxDeg - minDeg
      const maxRoot = 7 - span
      const root = Math.floor(Math.random() * maxRoot) + 1
      const shift = root - minDeg
      const heightMap = this.noteHeightMap()
      const nameMap = this.noteNameMap()
      const mapped = obstacles.map((o, idx) => {
        const note = degrees[idx] + shift
        return {
          ...o,
          note: String(note),
          height: heightMap[note],
          matchState: 'idle'
        }
      })
      const uniqueNotes = Array.from(new Set(mapped.map((o) => o.note)))
      if (uniqueNotes.length === 1) {
        const n = uniqueNotes[0]
        this.practiceNoteText = `本次练习音：${n}（${nameMap[n]}）`
      } else {
        this.practiceNoteText = `本次练习：${uniqueNotes.join('-')}（随机起音）`
      }
      return mapped
    },
    startOrStopRecording(index) {
      if (this.selectScale == index) {
        this.isRecording = !this.isRecording;
        return
      }
      this.selectScale = index
      this.isRecording = true
    },
    onClickLeftBack() {
      this.$router.back()
    },
    handleClick(tab) {
      this.selectTabName = Number(tab.name)
      this.selectScale = -1
      this.isRecording = false
      this.activeObstacleIndex = 0
      this.currentMatchState = 'idle'
      this.practiceNoteText = ''
      this.obstacleHeights = [{ id: 1, width: 0, height: 0, delay: 0, note: '', matchState: 'idle' }]
    },
    selectItem(index) {
      const item = this.currentList[index]
      if (!item) return
      // 同一关：录音中再点=暂停；暂停后再点=重新随机并开始
      if (this.selectScale === index && this.isRecording) {
        this.startOrStopRecording(index)
        return
      }
      let obstacles = (item.obstacles || []).map((o) => ({
        ...o,
        note: o.note || '',
        matchState: 'idle'
      }))
      if (this.selectTabName === 1) {
        obstacles = this.withRandomRhythmNotes(obstacles)
      } else {
        this.practiceNoteText = ''
      }
      this.obstacleHeights = this.withStartTiming(obstacles)
      this.activeObstacleIndex = 0
      this.currentMatchState = 'idle'
      this.$nextTick(() => {
        const refs = this.$refs.obstacle
        if (!refs) return
        const list = Array.isArray(refs) ? refs : [refs]
        list.forEach((ob) => ob && ob.updateData && ob.updateData())
      })
      this.selectScale = index
      this.isRecording = true
    },
    onAltitude(h) {
      const list = (this.obstacleHeights || []).filter((o) => o && o.height > 0)
      if (!list.length) return
      const tolerance = 12
      let nearestIdx = 0
      let nearestDiff = Infinity
      list.forEach((o, idx) => {
        const d = Math.abs(h - o.height)
        if (d < nearestDiff) {
          nearestDiff = d
          nearestIdx = idx
        }
      })
      this.activeObstacleIndex = nearestIdx
      let vis = 0
      ;(this.obstacleHeights || []).forEach((o) => {
        if (!o || !o.height) {
          if (o) this.$set(o, 'matchState', 'idle')
          return
        }
        const idx = vis++
        let matchState = 'idle'
        if (h >= 4) {
          const diff = h - o.height
          if (Math.abs(diff) <= tolerance) matchState = 'hit'
          else if (idx === nearestIdx && diff > tolerance) matchState = 'high'
          else if (idx === nearestIdx && diff < -tolerance) matchState = 'low'
        }
        this.$set(o, 'matchState', matchState)
      })
    },
  },
}
</script>
<style lang="less" scoped>
.van-nav-bar {
  background-color: #00000000;
}

audio {

  display: block;
  width: 200px;
  height: 40px;
  outline: none;
  filter: invert(180);
}


/* 自定义进度条样式 */
audio::-webkit-media-controls-progress-bar {
  height: 5px;
  /* 设置进度条高度 */
}

/* 自定义进度条填充样式 */
audio::-webkit-media-controls-play-button,
audio::-webkit-media-controls-volume-slider,
audio::-webkit-media-controls-timeline,
audio::-webkit-media-controls-mute-button,
audio::-webkit-media-controls-volume-slider-container,
audio::-webkit-media-controls-overflow-button audio::-webkit-media-controls-timeline-container {
  display: none !important;
  /* 隐藏默认控制按钮和音量控制条 */
}

// /* 自定义播放按钮样式 */
// audio::-webkit-media-controls-play-button {
//   width: 20px; /* 设置播放按钮宽度 */
//   height: 20px; /* 设置播放按钮高度 */
// }

// /* 自定义音量控制按钮样式 */
// audio::-webkit-media-controls-volume-slider {
//   width: 50px; /* 设置音量控制按钮宽度 */
//   height: 5px; /* 设置音量控制按钮高度 */
// }

// /* 自定义时间显示样式 */
// audio::-webkit-media-controls-current-time-display,
// audio::-webkit-media-controls-time-remaining-display {
//   font-size: 12px; /* 设置时间显示字体大小 */
// }

// /* 自定义音量控制按钮样式 */
// audio::-webkit-media-controls-volume-slider {
//   width: 50px; /* 设置音量控制按钮宽度 */
//   height: 5px; /* 设置音量控制按钮高度 */
// }

// /* 自定义音量控制滑块样式 */
// audio::-webkit-media-controls-volume-slider::-webkit-media-slider-thumb {
//   width: 10px; /* 设置音量控制滑块宽度 */
//   height: 10px; /* 设置音量控制滑块高度 */
// }
/* 需要滚动条隐藏的列表 */
.list-view {
  width: 90%;
  // height: 700px;
  margin-top: 10px;
  overflow-x: hidden;
  overflow-y: auto;
  // background-color: yellow;
}

/* 隐藏滚动条 */
.list-view::-webkit-scrollbar {
  display: none;
}

.el-card {
  --background-opacity: 0.15;
  background-color: rgba(255, 255, 255, var(--background-opacity)) !important;

  box-shadow: 0 5px 15px rgba(20, 20, 20, 0.6) !important;

  backdrop-filter: blur(50px) !important;
  border: none !important;
  border-radius: 5px !important;
  //    opacity: 0.75;
}

.el-card.selected {
  --background-opacity: 0.3;
  /* 修改选中时的透明度 */
}

.stage-tip {
  width: 90%;
  margin: 4px 0 4px;
  color: rgba(255, 255, 255, 0.75);
  font-size: 11pt;
  text-align: center;
  line-height: 1.4;
}

.practice-note {
  width: 90%;
  margin: 0 0 8px;
  color: #7dd3fc;
  font-size: 12pt;
  font-weight: 700;
  text-align: center;
}

.practice-card {
  width: 100%;
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 4px;
  box-sizing: border-box;
}

.nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.card-title {
  color: #fff;
  font-size: 16pt;
  font-weight: bold;
  line-height: 1.2;
}

.card-tip {
  margin-top: 6px;
  color: skyblue;
  font-size: 10pt;
  opacity: 0.9;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.el-col {
  border-radius: 4px;
  margin-bottom: 10px
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

/deep/ .el-tabs__nav {
  // width: 10px;
  //   font-size: 29px;
  // line-height: 55px;
  height: 35px;
}


::v-deep .el-tabs__item.is-active {
  color: skyblue; //选中
  opacity: 1;
}

::v-deep .el-tabs__item:hover {
  color: skyblue; //悬浮
  cursor: pointer;
  opacity: 1;
}

/deep/.el-tabs__item {
  /* 修改为您想要的文字大小 */
  font-size: 10pt !important;
  color: #fff;
  font-weight: bold;
}

/deep/.el-tabs__nav-wrap::after {
  /* 去掉下划线 */
  position: static !important;
}

/* 下划线颜色 */
::v-deep .el-tabs__active-bar {
  background-color: skyblue;
}

.obstacles-container {
  position: relative;
  width: 100%;
}

.practice-stage {
  overflow: hidden;
  background: linear-gradient(180deg, rgba(0, 20, 50, 0.35), rgba(0, 8, 30, 0.15));
}


/**背景 **/

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.kuang {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -10;
  background-image: linear-gradient(180deg, rgb(0, 6, 31), rgb(0, 2, 20));

}

.bubble {
  position: absolute;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: inset 0 0 8px #fff;
  animation: flutter 10s infinite;
  opacity: 0;
}

@keyframes flutter {
  0% {
    transform: translateX(0);
    bottom: -100px;
    opacity: 1;
  }

  50% {
    transform: translateX(100px);
    opacity: 0.5;
  }


  100% {
    transform: translateX(0px);
    bottom: 100%;
    opacity: 0;

  }
}

.bubble:nth-child(1) {
  left: -10%;
  width: 50px;
  height: 50px;
  animation-duration: 9s;
  animation-delay: 0.1s;
}

.bubble:nth-child(2) {
  left: 15%;
  width: 20px;
  height: 20px;
  animation-duration: 6s;
  animation-delay: 1.5s;

}

.bubble:nth-child(3) {
  left: 20%;
  width: 60px;
  height: 60px;
  animation-duration: 10s;



}

.bubble:nth-child(4) {
  left: 30%;
  width: 30px;
  height: 30px;
  animation-duration: 5.5s;
  animation-delay: 1.5s;

}

.bubble:nth-child(5) {
  left: 40%x;
  width: 50px;
  height: 50px;
  animation-duration: 12s;



}

.bubble:nth-child(6) {
  left: 50%;
  width: 20px;
  height: 20px;
  animation-duration: 6s;
  animation-delay: 1s;

}

.bubble:nth-child(7) {
  left: 60%;
  width: 40px;
  height: 40px;
  animation-duration: 8s;
  animation-delay: 1s;

}

.bubble:nth-child(8) {
  left: 65%;
  width: 60px;
  height: 60px;
  animation-duration: 15s;

}

.bubble:nth-child(9) {
  left: 80%;
  width: 55px;
  height: 55px;
  animation-duration: 9s;
  animation-delay: 0.5s;

}

.bubble:nth-child(10) {
  left: 100%;
  width: 40px;
  height: 40px;
  animation-duration: 12s;

}
</style>
